module.exports = __webpack_public_path__ + "media/images/help/header_01-c38cade78040b7e15f33c0cde7caa9d5.png";